"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, PropSync, Mixins } from "vue-property-decorator";
import { AccountSessionMixins } from "@/service/account-session";
let ItemRenew = class extends Mixins(AccountSessionMixins) {
  created() {
  }
  launcher() {
    return __async(this, null, function* () {
      this.$router.push({
        name: "payment",
        query: {
          style: "recycle"
        },
        params: {
          item: JSON.stringify(this._item)
        }
      });
    });
  }
  toDeleta() {
    this.$emit("realDeleteVD");
  }
};
__decorateClass([
  PropSync("item")
], ItemRenew.prototype, "_item", 2);
ItemRenew = __decorateClass([
  Component({})
], ItemRenew);
export {
  ItemRenew as default
};
